module.exports = __webpack_public_path__ + "static/media/ge.5f68e7f3.svg";